<template>
  <div class="mt-5 avalia" v-if="idTipoFormulario == idAvalia && urlIntegracaoLti">
    <div class="d-flex flex-column flex-xl-row align-items-center justify-content-center w-100">
      <div class="tutorial row text-center text-xl-left pb-4">
        <div class="col-lg-7">
          <a target="_blank" :href="urlIntegracaoLti">Acessar a avaliação</a><br><br>
          <p>Ainda não conhece o sistema avalia?</p>
          Veja como fazer para acessar a sua avaliação:
          <ul>
            <li><span>Após entrar no link acima, clique no botão <strong>Acessar avaliação.</strong></span></li>
            <li><span>Na página seguinte, clique em <strong>Li e Entendi</strong> e depois no botão <strong>Começar.</strong></span></li>
          </ul>
        </div>
        <div class="mt-5 col-lg-5 img-avalia">
          <img class="img-fluid" :src="imagemAvalia" alt="outra aba aberta">
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="typeformWidget"></div>
  </div>
</template>

<script>
import { createWidget } from '@typeform/embed'
import '@typeform/embed/build/css/widget.css'
import LoginUtils from '@/core/utils/login-utils'
import LtiAPI from '@/api/lti-api'
import TipoFormularioAvaliativo from '@/core/types/tipo-formulario-avaliativo'

export default {
  name: 'TopicoFormularioAvaliativo',
  props: {
    ementaCurso: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      urlIntegracaoLti: null,
      custom_avalia_atv: null,
      custom_avalia_td: null,
      contentId: null
    }
  },
  computed: {
    codigoExterno: function () {
      return this.ementaCurso.topico_escolhido.codigo_externo
    },
    usuario: function () {
      return LoginUtils.getUsuario()
    },
    idTipoFormulario: function () {
      return this.ementaCurso.topico_escolhido.tipo_formulario_avaliativo_id
    },
    imagemAvalia () {
      return require('@/assets/img/avalia.png')
    },
    urlAvalia () {
      return this.ementaCurso.topico_escolhido.url
    },
    idFormularioAvaliativo () {
      return this.ementaCurso.topico_escolhido.formulario_avaliativo_id
    },
    idAvalia () {
      return TipoFormularioAvaliativo.AVALIA.id
    },
    idTypeForm () {
      return TipoFormularioAvaliativo.TYPEFORM.id
    }
  },
  watch: {
    idFormularioAvaliativo: function () {
      this.$nextTick(() => {
        if (this.idTipoFormulario === this.idAvalia) {
          this.enviarDadosLti()
        } else if (this.idTipoFormulario === this.idTypeForm) {
          this.criarWidgetTypeform()
        }
      })
    }
  },
  methods: {
    pegarParametrosUrl: function () {
      const url = new URL(this.urlAvalia)
      const urlParams = new URLSearchParams(url.search)
      this.custom_avalia_atv = urlParams.get('custom_avalia_atv')
      this.custom_avalia_td = urlParams.get('custom_avalia_td')
      this.contentId = urlParams.get('contentId')
    },
    enviarDadosLti: async function () {
      this.pegarParametrosUrl()
      let launchData = {
        contentId: this.contentId,
        custom_avalia_atv: this.custom_avalia_atv,
        custom_avalia_td: this.custom_avalia_td,
        formulario_avaliativo_id: this.idFormularioAvaliativo
      }
      this.urlIntegracaoLti = await LtiAPI.urlIntegracaoLti(launchData)
      this.urlIntegracaoLti = this.urlIntegracaoLti.url
    },
    criarWidgetTypeform: function () {
      createWidget(this.codigoExterno, {
        container: document.querySelector('.typeformWidget'),
        hidden: {
          nome: this.usuario.name,
          email: this.usuario.email
        }
      })
    }
  },
  async mounted () {
    if (this.idTipoFormulario === this.idTypeForm) {
      this.criarWidgetTypeform()
    } else if (this.idTipoFormulario === this.idAvalia) {
      this.enviarDadosLti()
    }
  }
}
</script>

<style scoped>
  .typeformWidget {
    height: 887px;
  }

  @media (max-width:767px) {
    .typeformWidget {
      height: 500px;
    }
  }
</style>
